import { SVG_ICONS_INITIALIZER } from './svg-icons.initializer';
import { SvgIconNameInNamespaceByUrlPipe } from '@shared/svg-icons/pipes/svg-icon-name-in-namespace-by-url.pipe';
import { MatIconService } from '@shared/svg-icons/services/mat-icon.service';

export const SVG_ICONS_PROVIDERS = [
  SvgIconNameInNamespaceByUrlPipe,
  MatIconService,
  SVG_ICONS_INITIALIZER
];
